import { api } from "../Api.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe que faz as requisições das alocaçoes
 */
export class AlocacoesRequests {
    /**
     * Faz a requisição para pegar a alocação
     * @param {string} id do equipamento
     */
    async getAlocacao(id: string):Promise<any>{
        try {
            const response = await api.get(`/allocations/${id}`);
            return response;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar a alocação
     * @param id id da alocação a ser editado
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editAlocacao(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/allocations/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para pegar todas alocaçoes
     */
    async getAllAlocacoes(search: string ,page: number):Promise<any>{
        try {
            let response = {
                data : []
            }
            if(page && search){
                response = await api.get(`/allocations?search=${search}&page=${page}`);
            }else if(page){
                response = await api.get(`/allocations?page=${page}`);
            }else if(search){
                response = await api.get(`/allocations?search=${search}`);
            }else{
                response = await api.get(`/allocations`);
            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para criação da alocação
     * @param Body informações da alocação
     * method-spoofing
     */
    async CreateAlocacao(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/allocations`, Body);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz requisição para pegar a alocações que o usuário pode ver
     */
    async getlocations():Promise<any>{
        try {
            const response = await api.get(`/userAllocables`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz requisição para pegar a alocações que o usuário pode ver
     */
    async getlocationsType():Promise<any>{
        try {
            const response = await api.get(`/allocationsType`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async getStates():Promise<any>{
        try {
            const response = await api.get(`/states`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async getCities(uf: string):Promise<any>{
        try {
            const response = await api.get(`/states/${uf}/cities`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async addEquipamentToAlocacao(id: string, equipamento: string):Promise<any>{
        try {
            const response = await api.post(`/allocations/${id}/equipments`, {id_equipment: equipamento});
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async removeEquipamentToAlocacao(id: string, equipamento: string):Promise<any>{
        try {
            const response = await api.delete(`/allocations/${id}/equipments/${equipamento}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async addCityToAlocacao(id: string, city: string):Promise<any>{
        try {
            const response = await api.post(`/allocations/${id}/cities`, {city_code: city});
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async removeCityToAlocacao(id: string, city: string):Promise<any>{
        try {
            const response = await api.delete(`/allocations/${id}/cities/${city}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Busca os equipamentos que o usuário pode ver
    async getEquipaments(alocacaoId: string):Promise<any>{
        try {
            const response = await api.get(`/me/authorizedEquipments`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async getAllCities (alocacaoId: string):Promise<any>{
        try {
            const response = await api.get(`/me/authorizedCities`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}